import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import { useMemo } from 'react'
import TourCampaignFlightCreditDescription from 'components/Tours/TourCampaignFlightCreditDescription'
import { TOUR_CAMPAIGN_FLIGHT_CREDIT_INCLUSION_ID } from 'constants/tours'

interface Props {
  inclusion: App.OfferInclusion
}

function getIconColour(inclusion: App.OfferInclusion) {
  if (inclusion.isLuxPlusBonus) return 'lux-plus'
  if (inclusion.id === TOUR_CAMPAIGN_FLIGHT_CREDIT_INCLUSION_ID) return 'urgency'
  if (inclusion.isFlash) return 'exclusive'
  return 'highlight-primary-dark'
}

function TourV2HighlightedInclusionItem({ inclusion }: Props) {
  const Icon = useMemo(() => getOfferFeatureIcon(inclusion.symbol), [inclusion])
  return <BodyTextBlock
    variant="medium"
    colour={inclusion.isLuxPlusBonus ? 'lux-plus' : 'light-foreground-alt'}
    startIcon={<Icon colour={getIconColour(inclusion)} />}
  >
    {inclusion.id === TOUR_CAMPAIGN_FLIGHT_CREDIT_INCLUSION_ID ? <TourCampaignFlightCreditDescription /> : inclusion.description}
  </BodyTextBlock>
}

export default TourV2HighlightedInclusionItem
